import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PrimaryButton } from '../button'
import { useHistory, useParams } from 'react-router-dom'
import { findAppQuery, updateAppQuery } from '../../queries'
import { UpdateApp } from '../../queries/types/UpdateApp'
import { useMutation, useQuery } from '@apollo/client'
import { FindApp, FindAppVariables } from '../../queries/types/FindApp'
import { Field, FormCard, PageHeader, SecretKey, inputClassName } from '../ui'

export function AppEdit(): JSX.Element {
    const {t} = useTranslation()
    const history = useHistory()
    const { id: appID } = useParams<{id: string}>()
    const [ name, setName ] = useState('')
    const [ s2sUrl, setS2SUrl ] = useState('')
    const { data: appData } = useQuery<FindApp, FindAppVariables>(findAppQuery, {
        fetchPolicy: 'cache-and-network',
        variables: {
            id: appID
        }
    })
    const [ updateApp ] = useMutation<UpdateApp>(updateAppQuery)

    function updateThenGo() {
        updateApp({
            variables: {
                id: appID,
                name: name,
                s2sUrl: s2sUrl
            }
        }).then(() => {
            history.push('/apps')
        })
    }

    useEffect(() => {
        if (appData && appData.findApp) {
            setName(appData.findApp.name)
            setS2SUrl(appData.findApp.s2sUrl)
        }
    }, [appData])

    return (
        <>
            <PageHeader title={t('apps-create.title')} />
            <FormCard>
                <Field label={t('apps-create.form.label.name')}>
                    <input name='name' value={name} onChange={(e) => setName(e.target.value)} className={inputClassName} placeholder={t('apps-create.form.placeholder.name')} />
                </Field>
                <Field label={t('apps-create.form.label.s2s')}>
                    <input name='s2s' value={s2sUrl} onChange={(e) => setS2SUrl(e.target.value)} className={inputClassName} placeholder='https://' />
                </Field>
                {appData?.findApp ? (
                    <div className='mb-5'>
                        <span className='text-sm font-medium text-gray-700'>{t('apps.table.titles.key')}</span>
                        <div className='mt-1'><SecretKey value={appData.findApp.key} /></div>
                    </div>
                ) : null}
                <div className='mt-6 flex justify-end'>
                    <PrimaryButton onClick={() => updateThenGo()} type='submit'>{t('shared.button.label.submit')}</PrimaryButton>
                </div>
            </FormCard>
        </>)
}
